export const GET_TABLE= 'GET_TABLE'
export const GET_TABLE_SUCCESS= 'GET_TABLE_SUCCESS'
export const GET_TABLE_ERROR= 'GET_TABLE_ERROR'


export const GetTable= (data) => ({
    type: GET_TABLE,
    payload: data
});
